import { arrayMove } from "@dnd-kit/sortable";
/**
 * Move the input at `fromId` to where `toId` sits, preserving every other
 * input's relative order. `fromId`/`toId` are the dnd-kit sortable ids — the
 * array indices (see EditableInputsSection). Pure, so the reorder is
 * unit-testable without a drag harness.
 */ export function reorderInputs(inputs, fromId, toId) {
    return arrayMove(inputs, Number(fromId), Number(toId));
}

//# sourceMappingURL=stepInputsReorder.js.map